import { Link } from "react-router-dom";

export function NotFound() {
  return (
    <div className="auth-shell">
      <Link className="brand" to="/">
        <span className="brand-mark" aria-hidden="true" />
        Eventgram
      </Link>
      <div className="card empty-state">
        <span className="empty-icon" aria-hidden="true">
          🎈
        </span>
        <h1 style={{ fontSize: "1.6rem" }}>Not found</h1>
        <p className="muted">That link does not match any event.</p>
        <Link className="button" to="/">
          Go home
        </Link>
      </div>
    </div>
  );
}
